module.exports = __webpack_public_path__ + "img/1F6D1.0c953dad.svg";